import { trackStructuredEvent } from './snowplow';

export function trackPopupOpened(fromWhere: string) {
  trackStructuredEvent({
    action: 'opened',
    category: 'polaris-popup',
    property: fromWhere,
  });
}
